export const resources = {
  en: {
    translation: {
      titles: {
        return_to_account: 'Return to account details',
        subscription: 'Subscription',
        subscriptions: 'Subscriptions',
        loading: 'Loading...',
        back: 'Back',
        cancel: 'Cancel',
        save: 'Save',
        continue: 'Continue',
        pause: 'Pause',
        edit: 'Edit',
        my_subscriptions: 'My Subscriptions',
        frequency: 'Frequency',
        next_order: 'Next Billing Date',
        confirm: 'Confirm',
        remove: 'Remove',
        description: 'Description',
        add: 'Add',
        updating_subscription: 'Updating subscription…',
        logout: 'Logout',
      },
      calendar: {
        timezone_message: 'Dates are displayed in {{timezone}} timezone.',
      },
      aria_labels: {
        edit_next_order: 'Edit next order',
        cancel_edit_next_order: 'Cancel editing next order',
        edit_frequency: 'Edit frequency',
        cancel_edit_frequency: 'Cancel editing frequency',
        edit_shipment_info: 'Edit shipment info',
        edit_payment_method: 'Edit payment method',
        add_discount_code: 'Add discount code',
        cancel_add_discount_code: 'Cancel adding discount code',
        edit_phone_number: 'Edit phone number',
        close_slide_panel: 'Close slide panel',
        decrease_quantity: 'Decrease quantity by 1',
        increase_quantity: 'Increase quantity by 1',
        close_build_a_box: 'Close build a box',
        stars_number: '{{stars_qty}} out of 5 stars',
        carousel_page_indicators: 'Image carousel page indicators',
        carousel_page: 'Page {{index}} of {{total}}',
        carousel_image: 'Image {{index}} of {{total}}',
        previous_image: 'Previous image',
        next_image: 'Next image',
        select_size: 'Select a size',
        product_card: 'Open {{title}} product description',
        choose_button: 'Choose {{title}}',
        add_product: 'Add {{title}}',
        product_selected: '{{title}} selected',
      },
      email_gate: {
        no_subs: "You don't have any subscriptions yet",
        check_email: 'Check your email to access your subscriptions, {{email}}',
        cta_access_link: 'Email me an access link',
      },
      subscriptions: {
        error: 'There was an error loading your subscriptions',
        no_subs: "You don't have any subscriptions yet",
        link_to_account: 'Return to Account Details',
      },
      errorPage: {
        title: 'Error occurred while loading',
        description: 'Please retry after a few moments',
        btnCta: 'Retry',
      },
      subscription: {
        auth_error: 'There was authorization error, please login again',
        plan: 'Plan',
        active: 'Active',
        activate: 'Activate',
        pause: 'Pause',
        paused: 'Paused',
        cancel: 'Cancel',
        cancelled: 'Cancelled',
        expired: 'Expired',
        local_delivery_info: 'Local delivery info',
        shipment_info: 'Shipment info',
        pick_up_location: 'Pick up location',
        update_shipping: 'Update shipping',
        delivery_method: 'Delivery method',
        choose_delivery: 'Choose delivery method for this subscription',
        ship: 'Ship',
        pick_up: 'Pick up',
        pick_up_list_title: 'Available pick up locations',
        pick_up_list_subtitle:
          'Select a pick up location for this subscription',
        no_pick_up_locations: 'No pick up locations available',
        update_shipping_error:
          'Unfortunately, we do not ship to this location. Please contact {{shopEmail}} for more information.',
        payment_method: 'Payment method',
        pay_pal_payment_method: 'PayPal',
        ending_in: 'ending in',
        expires: 'Expires',
        add_phone: 'Enter a phone number',
        add_name: 'Enter your name',
        add_lastName: 'Enter your last name',
        billing_attepts: 'Billing Attempts',
        percentage_dynamic_discount: '{{discount}} % off',
        fixed_amount_dynamic_discount: '{{discount}} off',
        then_dynamic_discount: ' then {{discount}}',
        orders_dynamic_discount: ' for {{orderQty}} orders,',
        billing_attepts_empty: 'There are no billing attempts',
        billing_attepts_error:
          'There was an error loading the billing attempts',
        subs_details: 'Subscription Details',
        update_payment_btn: 'Update payment',
        cancel_prompt_title:
          'Canceling subscription cannot be undone. If you want to resume shipments, you will need to create a new order in the store.',
        cancel_error: 'There was an error trying to cancel your subscription',
        no_payment_method_error: 'Payment method missing from subscription.',
        no_payment_method_error_add: 'Please add a new card.',
        no_payment_method_error_gift:
          'Payment method missing from subscription. Contact merchant for assistance.',
        new_payment_method_success: 'Successfully updated the payment method.',
        new_payment_method_error:
          'Unknown error adding your payment method. Please try again.',
        new_known_payment_method_error: 'Error adding payment method',

        new_payment_method_dunning: {
          message:
            'Payment method updated. We will reattempt payment on {{ date }} or you can',
          cta: 'retry payment now',
        },
        remove_line_error: 'There was an error trying to remove the product',
        remove_line_success: 'Successfully removed the product',
        ships_to: 'Ships to',
        local_pickup: 'Local pickup',
        update_payment_success:
          'An email was sent to {{email}} with a secure link to update payment information.',
        update_payment_success_dunning:
          'An email was sent to {{email}} with a secure link to update payment information. After payment information is updated we will retry the order.',
        update_payment_success_payment_error:
          'Unable to add payment method. An email was sent to {{email}} with a secure link to update payment.',
        update_payment_error:
          'There was an error updating your payment information',
        sales_tax:
          'Sales tax (if applicable) is not displayed because it is calculated with each new order.',
        skip_billing_interval_prompt: 'Are you sure you want to skip?',
        skip_billing_interval_success:
          'Your next order has been rescheduled to {{date}}',
        skip_billing_interval_error:
          'There was an error skipping your next order',
        skip_shuffle_product: 'Product skipped',
        skip_until: 'Skip until',
        skip_next: 'Skip next',
        order_now: 'Order now',
        order_submitted: 'Submitted',
        next_order_success: 'Your next order has been rescheduled to {{date}}',
        next_order_error:
          "There was an error setting the subscription's next billing date.",
        add_new_address: 'Add new address',
        address_update_success: 'Address updated successfully',
        address_update_failed:
          'We encountered an unknown error. Please try again.',
        invalid_phone: 'The phone introduced is invalid',
        invalid_zip: 'The ZIP code introduced is invalid for that area',
        invalid_area: 'Unfortunately, we do not ship to this location',
        phone_required: 'A phone number is required for this shipping address',
        pause_subscription: 'Pause subscription',
        cancel_subscription: 'Cancel subscription',
        pause_disclaimer_date:
          'We will postpone your subscription. Your subscription will remain active, but you will not be charged until {{date}}.',
        pause_disclaimer_indefinitely:
          'You will not be charged while your subscription is paused. Reactivate your subscription anytime in your account.',
        pause_success: 'Your subscription was paused successfully',
        pause_error: 'There was an error pausing your subscription',
        reactivate_btn: 'Reactivate now',
        reactivate: 'Reactivate',
        reactivate_success:
          'Your subscription has been successfully reactivated.',
        reactivate_error:
          'Something went wrong while reactivating your subscription. Please try again',
        frequency_days: 'day(s)',
        frequency_weeks: 'week(s)',
        frequency_months: 'month(s)',
        frequency_2weeks: '2 weeks',
        frequency_1month: '1 month',
        frequency_2months: '2 months',
        custom: 'Custom',
        order_now_modal_body:
          'You will be charged {{amount}} and your shipment will go out as soon as possible.',
        order_now_modal_body_gifting:
          'Your shipment will go out as soon as possible.',
        amount: 'Amount',
        frequency_update_success:
          'Delivery frequency updated to {{ frequency }}.',
        frequency_update_error:
          'Unknown error. Delivery frequency could not be updated.',
        customer_update_success: 'Customer information has been updated',
        customer_phone_added_success: 'Phone number added',
        customer_phone_removed_success: 'Phone number removed',
        customer_update_error:
          'Unknown error. Customer information could not be updated.',
        customer_update_info:
          'Adding your phone number, you will receive free SMS with information about your next subscription, allowing you to skip it,or editing it through your phone',
        verified_phone: 'Phone verified',
        not_verified_phone: 'Phone not verified',
        verify_phone: 'Verify',
        enter_code: 'Enter the verification code',
        verify_code_error: 'There was an error verifying your phone number.',
        verify_code_retry_error:
          'You have tried to verify your phone number too many times. Please, try it later.',
        verify_code_success: 'Phone number verified successfully',
        code_received:
          'You must have received a confirmation code in the provided phone number.',
        code_enter: 'Please enter the code below to verify your phone number.',
        code_send: 'Send code',
        qty: 'Qty',
        manage: 'Manage',
        your_next_order: 'Your next billing date',
        your_next_gift_order: 'Your next gift order',
        swap_product: 'Swap products',
        swap_product_cta: 'Swap for another product',
        or: 'Or',
        update_variant: 'Change selection',
        update_bundle: 'Update Box',
        save: 'Save {{percentage}}%',
        failed_payment_message:
          'Failed payment with saved method. We will automatically retry payment on {{ date }}.',
        failed_payment_message_no_date:
          'Failed payment with saved method. We will automatically retry payment.',
        failed_payment_cta: 'Update Payment method',
        skip_order_cta: 'Skip order instead',
        order_now_success: 'Order submitted',
        order_now_error: 'Unknown error. Please try again.',
        update_current_payment_method: 'Update current payment method',
        add_new_card: 'Add new card',
        delayed: 'Delayed',
        delayedNotification:
          'Subscription delayed due to inventory. Order will ship when item becomes available. To receive order more quickly, please update selection below.',
        update_success: 'Your subscription has been updated successfully.',
        update_line_success:
          'Subscription updated. You will see the new price information shortly',
        update_dynamic_success:
          'Subscription has been updated successfully. You will see the new price information shortly.',
        update_line_success_in_held_of_inventory:
          'Subscription updated. The order will ship out on your next billing date',
        update_dynamic_success_in_held_of_inventory:
          'Subscription updated. You will see the new price information shortly. The order will ship out on your next billing date',
        update_error:
          'Something went wrong. Your subscription has not been changed.',
        failed_status_payment_message_1:
          'Failed payment with saved method. Please',
        failed_status_payment_message_2:
          ' and then retry payment to resume subscription.',
        failed_status_payment_cta: 'update payment method',
        retry_payment: 'Retry payment',
        retrying_status_message:
          'Retrying with payment method on file. This may take a few minutes.',
        retrying_status_cta: 'Refresh page',
        subscription_processing:
          'Subscription order processing. Updates cannot be made at this time.',
        failed_claimed_moment_message:
          'Something went wrong trying to claim your reward. Please try again.',
      },
      new_payment_method: {
        title: 'Enter payment method',
        payment_info: 'Payment information',
        card_number: 'Card number',
        exp_date: 'Exp date',
        security_code: 'CVV',
        first_name: 'First Name',
        last_name: 'Last Name',
        billing_address: 'Billing address',
        address1: 'Address',
        address2: 'Apartment, suite, etc. (optional)',
        city: 'City',
        country: 'Country/Region',
        state: 'State/Province',
        zip: 'Zip code',
        phone: 'Phone',
        instructions: 'Delivery instructions (optional)',
      },
      tables: {
        ID: 'ID',
        status: 'Status',
        item: 'Item',
        created: 'Created',
        next_order: 'Next Billing Date',
        skip: 'Skip',
        restore: 'Restore',
        product: 'Product',
        quantity: 'Quantity',
        price: 'Price',
        total: 'Total',
        shipping: 'Shipping',
        shippingDiscount: 'Shipping Discount',
        originated: 'Originated',
        frequency: 'Frequency',
        phone: 'Phone',
        name: 'Name',
        lastName: 'Last name',
        date: 'Date',
        sold_out: 'Sold out',
        upcoming_product: 'Upcoming product.',
        upcoming_products: 'Upcoming products.',
        curate_upcoming: 'Curate upcoming',
        curate_upcoming_products: 'Curate upcoming products',
        next_order_will_contain: 'Next order will contain',
        up_next: 'Up next',
        skipped_or_delivered: 'Skipped or delivered',
        no_items_available: 'No items are available',
        box_content: 'Box content',
        partial_inventory: 'Partial inventory',
        qty_sold_out: ' • {{quantity}} sold out',
        order_number: 'Order Number',
        subtotal: 'Subtotal',
        loading_fulfillments: 'Loading...',
        last_fulfillment: 'Last fulfillment',
        next_fulfillment: 'Next fulfillment',
        merchant_discount: 'Discount',
        prepaid_orders_discount: 'Prepaid ({{currentCount}} of {{totalCount}})',
        one_time_discount_label: '(One-time)',
        finite_discount_label: '({{usageCount}} of {{recurringCycleLimit}})',
        subscription_discount: '{{prefix}} {{suffix}}',
        box_discount: {
          percentage: 'Box discount ({{value}}%)',
          amount: 'Box discount ({{value}})',
        },
        edit: 'Edit',
        close: 'Close',
      },
      billingHistory: {
        title: 'Billing history',
        order: 'Order',
        date: 'Date',
        status: 'Status',
        submitted: 'Submitted',
        challenged: 'Challenged',
        failed: 'Failed',
        success: 'Success',
        loadMore: 'Load more',
        bankChallenge: 'Complete Challenge',
      },
      babFilters: {
        filters: 'Filters',
        reset: 'Reset',
      },
      login: {
        welcome: 'Welcome',
        welcome_back: 'Welcome back',
        start_intro: 'Enter your email address to get started',
        auth_intro_email_phone:
          "We've sent a verification code to your email and phone",
        auth_intro_email: "We've sent a verification code to your email",
        continue: 'Continue',
        email: 'Email',
        different_email: 'Try different email',
        resend_code: 'Resend code',
        invalid_email: 'Invalid Email',
        invalid_email_no_order: 'No order found with this email address',
        invalid_code: 'Invalid or expired code. Please try again',
        network_error: 'There is a server error, please try again',
        network_error_abuse:
          'Please, wait a moment before requesting a new code',
      },
      product_swap: {
        title_select: 'Choose replacement item',
        title_confirm: 'Confirm',
        sold_out: 'Sold out',
        choose: 'Choose',
        customize_bundle: 'Customize my box',
        back: 'Back',
        confirm: 'Confirm',
        save: 'Save',
        update: 'Update',
        original_item: 'Original item',
        replacement_item: 'Replacement item',
        empty: 'There are no items available to swap for this product.',
        fetch_error: 'Something went wrong while fetching products.',
        retry: 'Retry',
        update_success: 'Successfully swapped items for the next order.',
        update_error:
          'Something went wrong. Your subscription has not been changed.',
        error: 'Error',
        add: 'Add',
        in_box: 'In box',
      },
      bundles: {
        reviews: 'Reviews',
        build_box: 'Build your box',
        of: 'of',
        back: 'Back',
        continue: 'Continue',
        add_cart: 'Add to cart',
        select_plan: 'Select plan',
        build_your_box: 'Build your box',
        addons: 'Extras',
        checkout: 'Checkout',
        edit_my_box: 'Edit my box',
        box_size: 'Box size',
        add_cart_error: 'There was an error updating your cart.',
        update_price:
          'Cost of the box has changed from {{prevBasePrice}} to {{basePrice}}',
        new_box_size:
          'Previously selected box size is no longer available. Choose at least {{newSize}} items to continue. Cost of the box has change to {{newPrice}}.',
        bundle_stock_updated:
          'Some items that you currently have selected are sold out. Please select new items to continue.',
        update_success: 'Box successfully updated',
        update_error: 'Something went wrong trying to update the box',
        update_error_reload:
          'Something went wrong trying to update the box. Please, reload the page and try it again',
        delivery_options: 'Delivery options',
        one_time_delivery: 'One time',
        additional_products: 'Additional products',
        save: 'Save',
        cartOutOfStock: 'One of the addons added in your box is out of stock',
        cartOutOfStockWithDetails:
          'Only a few available of "{{product}}", please lower the quantity selected and try again.',
        cartItemNoSellingPlan:
          'One of the items in your box are not included in the subscription plan, please contact the merchant',
        cartAlreadyInCart:
          'All the available resources of "{{product}}" are already in your cart',
        cartDefaultError:
          'There was an error updating your cart. Please contact the merchant',
        dynamicSize: {
          item: {
            singular: 'item',
            plural: 'items',
          },
          selection: '{{count}} {{item}}',
          min: '{{count}} {{item}} min.',
          max: '{{count}} {{item}} max.',
        },
      },
      addons: {
        title: 'Add Items',
        selection_unavailable: 'Selection unavailable',
        success_added: 'Successfully added items to your subscription.',
        subtitle: 'Add items to your upcoming order',
        subscribe: 'Subscribe',
        select: 'Add',
        see_products: 'See all products',
        modal_title: 'Add products to your next order',
        save: 'Save',
        type: 'Type',
        one_time: 'One-time',
        subscription: 'Subscription',
        help: {
          one_time:
            'This product will be added as a one-time item. It will automatically be removed after your next order.',
          subscription:
            'This product will be added as a recurring item on your subscription until removed.',
        },
      },
      prepaid: {
        prepaidOrderQty: 'Prepaid: {{completedQty}} of {{orderQty}}',
        expiredAfter: 'Expired after {{orderQty}} orders',
        autoRenews: 'Autorenews',
      },
      sms: {
        title: 'Phone number',
        add: 'Add',
        edit: 'Edit',
        edit_phone: 'Edit phone number',
        enable_phone: 'Add phone number',
        phone_placeholder: 'Enter phone number',
        enable_phone_text:
          'Enter a phone number to keep your account secure and log in faster. Message and data rates may apply.',
        enable_phone_notifications_text:
          'Enter a phone number to keep your account secure and log in faster. Text messages also allow you to update subscriptions on the go. Message and data rates may apply.',
        phone: 'Phone number',
        invalid_phone: 'Invalid phone number',
        invalid_country: 'Only US and CA phone numbers are supported.',
        consent_marketing_label:
          'I consent to receive marketing communications via SMS.',
        duplicated_phone_error: 'Phone number already in use',
        remove_phone: 'Remove phone number',
      },
      pauseModal: {
        delaySubscriptionTitle: 'Delay subscription available',
        delaySubscriptionSubtitle: 'Consider delaying subscription instead',
        delaySubscriptionBody:
          'By delaying your subscription, you can make sure orders start again without needing to remember to turn them back on.',
        delaySubscriptionCta: 'Delay subscription',
        pauseModalTitle: 'Pause subscription',
        pauseModalLabel: 'Pause subscription for',
        pauseModalBody:
          'You will not be charged while your subscription is paused. Reactivate your subscription anytime in your account',
        continueToPause: 'Continue to Pause',
        neverMind: 'Never mind',
        back: 'Back',
        save: 'Save',
        confirmPause: 'Confirm',
        delaySubscription: 'Delay subscription',
        ONE_MONTH: '1 month',
        TWO_MONTH: '2 months',
        THREE_MONTH: '3 months',
        CUSTOM: 'Custom',
      },
      reactivateModal: {
        title: 'Reactivate subscription',
        body: 'When would you like to start billing again?',
        neverMind: 'Never mind',
        save: 'Save',
        inputLabel: 'Restart billing on',
        error: 'There was an error trying to reactivate your subscription',
        placeholder: 'Select a date',
      },
      discountCodeCard: {
        title: 'Discount Code',
        addBtn: 'Add',
        cancelBtn: 'Cancel',
        inputPlaceholder: 'Enter code',
        applyBtn: 'Apply',
        successMsg: 'Discount applied to subscription',
        removeSuccessMsg: 'Discount removed from subscription',
        loadingMsg: 'Adding discount code...',
        errorMsg: 'Invalid code',
        boxDiscount: 'Box discount',
      },
      cancelModal: {
        header: 'Reason for cancelling',
        neverMind: 'Never mind',
        back: 'Back',
        continue: 'Continue',
        continueWithCancellation: 'Continue with cancellation',
        continueCancel: 'Continue cancel',
        confirmCancellation: 'Confirm cancellation',
        error: 'There was an unknown error',
        tryAgain: 'Try again.',
        TOO_MUCH: 'I have too much',
        MOVING: 'Moving to a new place',
        COMPETITOR: 'Switching to a competitor',
        BUDGET: 'Doesn’t fit my budget',
        NOT_ENJOY: 'I didn’t enjoy the product',
        NO_NEED: 'No longer need this',
        TRAVELLING: 'I’m traveling',
        OTHER: 'Other',
        frequency: {
          modalTitle: 'Frequency update available',
          title: 'Update frequency instead of losing subscription',
          subtitle:
            'By updating your delivery frequency, you can control how often you receive shipments.',
          updateFrequency: 'Update frequency',
          formModalTitle: 'Edit frequency',
          formTitle:
            'You control how often your receive deliveries. Upcoming orders will be delivered on the frequency selected below.',
          formDelivery: 'Delivery every',
          setFrequency: 'Set frequency',
        },
        address: {
          modalPromptTitle: 'Address update available',
          promptTitle: 'Moving doesn’t have to mean cancellation',
          promptSubtitle:
            'By updating your address, you have the option of keeping your subscription with you wherever you go!',
          promptUpdateAddress: 'Update address',
          modalFormTitle: 'Enter address',
          noShippingOptions:
            'There are no shipping options available for that address.',
          confirmModalTitle: 'Shipping confirmation',
          confirmTitle:
            'The price of shipping for your subscription will change from {{oldPrice}} to {{newPrice}} because your new address is in a different delivery zone.',
          confirmAcceptShipping: 'Accept shipping',
          newAddress: 'New address:',
          oldAddress: 'Old address:',
        },
        discount: {
          title: 'Discount available',
          claimDiscount: 'Claim Discount',
          cta: 'Continue cancel',
          add_discount_error: 'There was an error trying to add a discount',
          add_discount_success: 'Successfully added a discount',
        },
        pause: {
          header: 'Pause available',
          title: 'Did you know you can pause instead?',
          description:
            'Instead of cancelling, pausing your subscription allows you to keep billing and shipping details saved when you’re ready to reactivate your subscription.',
          cta: 'Pause subscription',
          success: 'Your subscription was paused successfully',
        },
        skip: {
          header: 'Edit order date available',
          title: 'You can skip or reschedule your next order',
          description:
            'Keep your shipments coming once you’re back from your trip. Consider skipping or rescheduling instead of canceling.',
          titleHideSkip: 'You can reschedule your next order',
          descriptionHideSkip:
            'Keep your shipments coming once you’re back from your trip. Consider rescheduling instead of canceling.',
          titleHideEditNextOrderDate: 'You can skip your next order',
          descriptionHideEditNextOrderDate:
            'Keep your shipments coming once you’re back from your trip. Consider skipping instead of canceling.',
          ctaReschedule: 'Reschedule next order',
          ctaSkip: 'Skip next',
          success: 'Your next order has been rescheduled to {{date}}',
        },
        reschedule: {
          header: 'Schedule next order',
          confirmReschedule: 'Reschedule',
          dateFormat: 'mm/dd/yyyy',
          inputLabel: 'Next order',
          description:
            'Your subscription will remain active, but we will postpone your subscription until the date you select below.',
        },
        confirm: {
          modalTitle: 'Additional feedback',
          title: 'Please provide additional feedback (optional)',
          buttonConfirm: 'Confirm',
          buttonContinue: 'Continue',
          success: 'Subscription cancelled',
        },
        confirmPrepaid: {
          modalTitle: 'Cancel prepaid subscription',
          description:
            'Your prepaid subscription cannot be canceled immediately as you have remaining orders in your current prepaid term. By confirming, your subscription will be updated to stop auto-renewing. You will continue to receive the remaining shipments in this term but will not be billed again.',
          button: 'Confirm',
          success: 'Subscription cancelled',
        },
        prepaidMultiOrder: {
          modalTitle: 'Cancel prepaid subscription',
          expireDescription:
            'By confirming, your subscription will be set to expire, and the upcoming billing will be canceled to prevent future charges. You will not receive any additional shipments or charges.',
          description:
            'Your prepaid subscription cannot be canceled immediately as you have remaining orders in your current prepaid term. By confirming, your subscription will be updated to stop auto-renewing. You will continue to receive the remaining shipments in this term but will not be billed again.',
          button: 'Disable autorenew',
          success: 'Prepaid items will not autorenew',
          expireSuccess: 'Subscription Expired',
          autoRenewDisabledSuccess: 'Autorenew disabled',
        },
      },
      lastOrder: {
        title: 'Previous order • {{orderDate}}',
        fulfilledStatus: 'Shipped',
        unfulfilledStatus: 'Not Shipped',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        tax: 'Tax',
        total: 'Total',
      },
      drawers: {
        updateAddress: {
          title: 'Enter address',
        },
      },
      moments: {
        claimReward: 'Claim reward',
        productList: {
          modal: {
            title: 'Select reward',
          },
        },
        claimToast: {
          title: 'Reward claimed',
        },
        claimErrorToast:
          'There was a problem previewing your moment. Please, try again later.',
      },
      preview: {
        close: 'Close',
      },
      frequency: {
        once_a: 'Once a',
        every: 'Every',
        day: 'day',
        week: 'week',
        month: 'month',
        year: 'year',
        days: 'days',
        weeks: 'weeks',
        months: 'months',
        years: 'years',
      },
    },
  },
  es: {
    translation: {
      titles: {
        subscriptions: 'Subscripciones',
      },
      email_gate: {
        no_subs: 'Aún no tienes ninguna subscripción',
        check_email:
          'Revisa tu email, {{email}}, para acceder a tus subscripciones',
        cta_access_link: 'Obtener link de acceso',
      },
      lastOrder: {
        title: 'Última orden • {{orderDate}}',
        fulfilledStatus: 'Enviado',
        unfulfilledStatus: 'No enviado',
        subtotal: 'Subtotal',
        shipping: 'Envío',
        tax: 'Impuestos',
        total: 'Total',
      },
    },
  },
};
